<div *ngIf="isOpen" class="popover {{ position }}" #popoverContent>
    <div class="popover-title pb-1 font-weight-bold" *ngIf="title">{{ title }}</div>
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>